<template>
  <tr class="data-grid__row" v-if="!update">
    <td
      class="data-grid__cell data-grid__controlRowCell"
      :class="{ _noControls: inherited && lockedForInherited }"
    >
      <div v-if="!inherited || !lockedForInherited">
        <b-button
          v-if="!dgRowInEditMode[gridId + '.' + rowKey]"
          variant="primary"
          size="sm"
          @click="editRow"
          :disabled="inProcess"
        >
          open
        </b-button>
        <b-button
          v-if="(options.isReactive || typeof options.isReactive === 'undefined') || (!options.isReactive && !dgRowInEditMode[gridId + '.' + rowKey])"
          variant="success"
          size="sm"
          @click="toggleEditMode"
          :disabled="inProcess"
        >
          <span v-if="dgRowInEditMode[gridId + '.' + rowKey]">done</span>
          <span v-else>edit</span>
        </b-button>
        <span v-if="options.isReactive === false && dgRowInEditMode[gridId + '.' + rowKey]">
          <b-button
            variant="success"
            size="sm"
            @click="save"
            :disabled="inProcess"
          >
            <span v-if="rowData._created">save</span>
            <span v-else>create</span>
          </b-button><!--
          --><b-button
            variant="danger"
            size="sm"
            @click="cancel"
            :disabled="inProcess"
          >
            cancel
          </b-button>
        </span>
      </div>
    </td>
    <td class="data-grid__cell">
      <div>{{ rowId }}</div>
    </td>
    <slot ref="children" />
    <td
      class="data-grid__cell data-grid__controlRowCell"
      :class="{ _noControls: inherited && lockedForInherited }"
    >
      <div v-if="!inherited || !lockedForInherited">
        <b-button
          variant="danger"
          size="sm"
          class="delete-button"
          @click="removeRow"
          :disabled="inProcess"
        >
          <icon name="remove" />
        </b-button>
      </div>
    </td>
  </tr>
</template>

<script>
import { mapState } from 'vuex'
import { cloneDeep } from 'lodash'
// helpers
import eventBus from '@/helpers/event-bus'
// services
import db from '@/services/db'

export default {
  props: [
    'options', 'rowKey',
    'gridId', 'widgetKey',
    'editMode', 'fbField',
    'inherited', 'lockedForInherited',
  ],
  data() {
    return {
      rowData: {},
      update: false,
      inProcess: false
    }
  },
  computed: {
    ...mapState([
      'currentDash',
      'currentTab',
      'dgRowInEditMode'
    ]),
    rowId () {
      if (!$dataGrid(this.gridId)) return null
      if (!$dataGrid(this.gridId)[this.rowKey]) return null
      return $dataGrid(this.gridId)[this.rowKey]['_id']
    },
  },
  methods: {
    removeRow () {
      if (!confirm('Are you sure?')) return

      db.dataGrid.data.removeRow(this.gridId, this.rowKey)
    },
    editRow () {
      if (this.fbField) {
        $dgShowEditRowModal(this.gridId, this.rowKey)
      } else {
        const currentQuery = JSON.stringify(this.$route.query)
        const editQuery = {
          dgEditMode: true,
          gridId: this.gridId,
          rowKey: this.rowKey
        }
        const query = Object.assign(JSON.parse(currentQuery), editQuery)

        this.$router.push({ path: '/dashboard/' + this.currentDash, query })
      }
    },
    toggleEditMode ($event, done) {
      if (done) this.rowData = {}
      else this.rowData = cloneDeep($dataGrid(this.gridId)[this.rowKey])

      this.update = true
      this.$nextTick(() => {
        this.update = false
      })

      this.$store.commit('toggleDGRowEditMode', this.gridId + '.' + this.rowKey)
      const dgInst = this.$instByClass(this, 'data-grid')
      dgInst.updateHandyScroll()
    },
    save() {
      if (!this.validate()) {
        this.$bvToast.toast('There are errors on the row. Please rectify the errors so the action can be completed.', {
          title: 'Failed!',
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 2500,
        })

        return
      }

      this.inProcess = true

      const emitCreated = $dataGrid(this.gridId)[this.rowKey]._created ? false : true

      db.dataGrid.data.saveRowData(
        this.gridId,
        this.rowKey,
        Object.assign(
          { _created: true },
          this.rowData
        )
      ).then(() => {
        this.toggleEditMode(null, true)
        this.inProcess = false

        if (emitCreated)
          eventBus.$emit(`simpleWorkflow-rowCreated-${this.gridId}`, $dataGrid(this.gridId)[this.rowKey])
        else
          eventBus.$emit(`simpleWorkflow-rowUpdated-${this.gridId}`, $dataGrid(this.gridId)[this.rowKey])
      })
    },
    cancel() {
      try {
        const row1 = JSON.stringify(cloneDeep($dataGrid(this.gridId)[this.rowKey]))
        const row2 = JSON.stringify(this.rowData)

        if (row1 !== row2) {
          if (!confirm('Are you sure?')) return

          this.rowData = {}
        }
      } catch(err) {
        console.error(err)
      }

      this.update = true
      this.$nextTick(() => {
        this.update = false
      })

      this.toggleEditMode(null, true)
    },
    validate() {
      let hasErrors = false

      for (let child of this.$children) {
        if (child.$options.name !== 'cell') continue

        const cellInput = child.$children[0]
        if (!cellInput) continue
        const $v = cellInput.$v

        if (!$v) continue

        $v.$touch()

        if ($v.$error) hasErrors = true
      }

      return !hasErrors
    },
  },
  beforeDestroy() {
    this.rowData = null
    this.update = null
    this.inProcess = null
  }
}
</script>

<style lang="scss">
@import "~$scss/globals";

.data-grid {
  &__controlRowCell > div {
    flex-direction: row !important;
    justify-content: flex-start !important;
    .btn {
      margin-right: 5px;
      &:last-child {
        margin-right: 0;
      }
      svg {
        vertical-align: -4px;
      }
    }
  }
  &__row {
    border-bottom: 1px solid #e9ecef;
    @include breakpoint(max-width $screenMd) {
      border: {
        left: 1px solid #e9ecef;
        right: 1px solid #e9ecef;
      }
    }
  }
}
.delete-button{
  display: flex;
  justify-content: center;
  align-items: center;
  padding: .25em;
  font-size: 16px;
  border: none;
  border-radius: 4px;
}
</style>
